export const SET_PAYMENTS = 'SET_PAYMENTS';
